import React from 'react';
import { Tooltip } from 'antd';
import { FaExclamationCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import AmenitiesTooltip from '../../../ViewFlight/AdditionalFaresFlightBox/AmenitiesTooltip';

interface AirlineLogoWithToolTipProps {
  airline: any;
  isFlightExist: boolean;
  firstFlight?: any;
  showAirlineInfoTitle?: boolean;
}

export const AirlineLogoWithToolTip = ({
  airline,
  isFlightExist,
  firstFlight,
  showAirlineInfoTitle = true,
}: AirlineLogoWithToolTipProps) => {
  const { searchDatePicker: t, general: t_general } = useSelector(
    (data: RootState) => data.config.translations
  );
  const logo = airline?.image || airline?.logo;

  return (
    <div className="airline-logo-with-tooltip-wrapper">
      {firstFlight ? (
        <div className="amenities-tooltip">
          <AmenitiesTooltip flightFrom={firstFlight} isShowFullText={false} />
        </div>
      ) : null}

      {airline?.id ? (
        <Tooltip
          title={airline?.name + ' - ' + t.airlineCode + ' ' + airline.id}
        >
          <div className="airline-logo-with-tooltip">
            {isFlightExist && logo ? (
              <img src={logo} className="logo" />
            ) : (
              <span>{airline?.id}</span>
            )}
            {showAirlineInfoTitle && (
              <div className="airline-info">
                <FaExclamationCircle />
                <span>{t.airlineInformation}</span>
              </div>
            )}
          </div>
        </Tooltip>
      ) : null}
    </div>
  );
};